export default __webpack_public_path__ + "static/media/Plugin-StrikezoneHunter.1b2940b2.png";